import { useCallback } from "react";

export const TOAST_ACTIONS = {
  ADD: "toast-add",
  REMOVE: "toast-remove",
};

export const TOAST_TYPES = {
  SUCCESS: "toast-success",
  ERROR: "toast-error",
  INFO: "toast-info",
  WARNING: "toast-warning",
};

export default function useToast() {
  const addToast = useCallback(
    (type, message, options = {}) =>
      window.dispatchEvent(
        new CustomEvent(TOAST_ACTIONS.ADD, {
          detail: {
            type,
            message,
            ...options
          },
        })
      ),
    []
  );

  const removeToast = useCallback(
    (id) =>
      window.dispatchEvent(
        new CustomEvent(TOAST_ACTIONS.REMOVE, {
          detail: { id },
        })
      ),
    []
  );

  return [addToast, removeToast];
}